<template>
  <div class="yonghuyemian">
    <Nav></Nav>
    <div style="height: 80px"></div>

    <div class="yonghuyemian-bottom">
      <div class="yonghuyemian-bottom-top" v-if="data.userInfo">
        <!-- <div class="yonghuyemian-bottom-top-top">
                <img v-if="data.userInfo.background" style="width: 100%;height: 100%;background-size:100% 100%;" :src="data.userInfo.background" alt="">
                <img v-else style="width: 100%;height: 100%;background-size:100% 100%;" src="https://oss.ansongqiubo.com/Image/userimage/userbj.png" alt="">
            </div> -->
        <div class="yonghuyemian-bottom-top-bottom">
          <div class="userinfo_img">
            <img :src="data.userInfo.avatar" alt="" />
          </div>
          <div class="userInfo_title">
            <div class="userinfo_box">
              <div class="name">
                {{ data.userInfo.nickname }}
              </div>
              <div class="userinfo_grede">
                <img style="border-radius: 0;" :src="'/static/newhome/l' + data.userInfo.level + '.webp'
                  " alt="" />
              </div>
            </div>
            <div ref="zhankai" class="userinfo_desc">
              个人简介：
              <span>{{
                data.userInfo.desc
                  ? data.userInfo.desc
                  : "这个人很懒什么都没有留下"
              }}</span>
            </div>
            <!-- <div v-if="Zhankai" @click="zhankai" class="show">
              展开
              <img src="https://oss.ansongqiubo.com/Image/userimage/shouqi.png" alt="" />
            </div>
            <div v-else @click="shouqi" class="hiddens">
              收起
              <img src="https://oss.ansongqiubo.com/Image/userimage/zhankai.png" alt="" />
            </div> -->
          </div>
          <!-- <div class="showCare_btn">
            <div class="showCare_box">
              <div class="jubao">举报</div>
              <div class="care">
                {{ isshowCare ? "已关注" : "+ 关注" }}
              </div>
            </div>
          </div> -->
          <router-link
            to="personalc"
            class="edit_user"
            ><span>编辑</span></router-link
          >
        </div>
      </div>
      <div class="yonghuyemian-bottom-center">
        <div style="display: flex; width: 80%">
          <div @click="Zuopin">
            <div
              :class="henggang == 1 ? 'activenav' : ''"
              class="nav_item"
              style=""
            >
              关注
            </div>
          </div>
          <div style="margin-left: 70px" @click="Shoucang">
            <div class="nav_item" :class="henggang == 2 ? 'activenav' : ''">
              粉丝
            </div>
            <!-- <div
              v-if="henggang == 2"
              style="width: 32px; height: 2px; background: #721edc"
            ></div> -->
          </div>
        </div>
        <!-- <div style="display: flex; width: 20%" v-if="data.relation">
          <div>
            <div style="text-align: center; color: #d5d5d5; font-size: 20px">
              {{ data.relation.fans }}
            </div>
            <div style="text-align: center; font-size: 14px; color: #a6a6a6">
              粉丝
            </div>
          </div>
          <div style="margin-left: 70px">
            <div style="text-align: center; color: #d5d5d5; font-size: 20px">
              {{ data.relation.follows }}
            </div>
            <div style="text-align: center; font-size: 14px; color: #a6a6a6">
              关注
            </div>
          </div>
        </div> -->
      </div>
      <div class="yonghuyemian-bottom-bottom">
        <div class="yonghuyemian-bottom-bottom-left">
          <div class="_fensi_list">
            <div
              v-show="a"
              class="_fensi_item"
              v-for="(item, index) in guanzhudata.later"
              :key="index"
            >
              <div class="header_class" >
                <img :src="item.avatar" alt="" />
              </div>
              <div class="nickname">
                <div class="name">
                  {{ item.nickname }}
                </div>
                <div class="desc">
                  {{ item.desc ? item.desc : "用户很懒什么都没留下" }}
                </div>
              </div>

               <div
                    @click="quxiaoguanzhu(item.uid)"
                    v-if="item.status == 2"
                    class="double_care"
                  >
                   <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png"
                      alt=""
                      srcset=""
                    />
                    <span>互相关注</span>
                  </div>
              <div
                v-else
                  class="double_care"
                @click="quxiaoguanzhu(item.uid)"

              >
               <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_dui@2x.png"
                      alt=""
                      srcset=""
                    />
                <span>已关注</span>
              </div>

              <!-- <div
                v-show="faxiaoxi"
                style="
                  cursor: pointer;
                  box-sizing: border-box;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 50px;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>发消息</span>
              </div> -->
            </div>
            <div
              v-show="a"
               class="_fensi_item"
              v-for="(item, index) in guanzhudata.today"
              :key="'info1-' + index"
            >
              <div
               class="header_class"
              >
                <img
                  :src="item.avatar"
                  alt=""
                />
              </div>
              <div class="nickname">
                <div  class="name">
                  {{ item.nickname }}
                </div>
                <div class="desc">
                                   {{ item.desc ? item.desc : "用户很懒什么都没留下" }}

                </div>
              </div>


              <div
                v-if="item.status === 2"
                @click="quxiaoguanzhu(item.uid)"
                   class="double_care"
                  >
                   <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png"
                      alt=""
                      srcset=""
                    />
                    <span>互相关注</span>
              </div>
              <div
                v-else
                @click="quxiaoguanzhu(item.uid)"
                class="double_care"
              >
                 <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_dui@2x.png"
                      alt=""
                      srcset=""
                    />
                <span>已关注</span>
              </div>
              <!-- <div
                v-show="faxiaoxi"
                style="
                  cursor: pointer;
                  box-sizing: border-box;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 50px;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>发消息</span>
              </div> -->


            </div>
            <div
              v-show="aa"
              class="_fensi_item"
              v-for="(item, index) in fensidata.later"
              :key="'info2-' + index"
            >
              <div
                 class="header_class"
              >
                <img

                  :src="item.avatar"
                  alt=""
                />
              </div>
              <div  class="nickname">
                <div class="name">
                  {{ item.nickname }}
                </div>
                <div class="desc">
                   {{ item.desc ? item.desc : "用户很懒什么都没留下" }}
                </div>
              </div>

              <div
                v-if="item.status === 2"
                   class="double_care"
                  >
                   <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png"
                      alt=""
                      srcset=""
                    />
                    <span>互相关注</span>
              </div>
              <div
                v-else
                @click="Guanzhu(item.uid)"
                class="redia_guanzhu"
              >
                <span>+ 关注</span>
              </div>
              <!-- <div
                v-show="faxiaoxi"
                style="
                  cursor: pointer;
                  box-sizing: border-box;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>发消息</span>
              </div> -->

            </div>
            <div
              v-show="aa"
             class="_fensi_item"
              v-for="(item, index) in fensidata.today"
              :key="'info3-' + index"
            >
              <div
              class="header_class"
              >
                <img

                  :src="item.avatar"
                  alt=""
                />
              </div>
              <div class="nickname">
                <div class="name">
                  {{ item.nickname }}
                </div>
                <div class="desc">
                   {{ item.desc ? item.desc : "用户很懒什么都没留下" }}
                </div>
              </div>


              <div
                v-if="item.status === 2"
                  class="double_care"
                  >
                   <img
                      src="https://oss.ansongqiubo.com/assets/person/icon_huxiang@2x.png"
                      alt=""
                      srcset=""
                    />
                    <span>互相关注</span>
              </div>
              <div
                v-else
                @click="Guanzhu(item.uid)"
                style="
                  cursor: pointer;
                  box-sizing: border-box;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 50px;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>关注</span>
              </div>
              <!-- <div
                v-show="faxiaoxi"
                style="
                  cursor: pointer;
                  box-sizing: border-box;
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-top: 50px;
                  width: 86px;
                  height: 36px;
                  border-radius: 4px;
                  border: 1px solid #e4e4e4;
                  color: #e4e4e4;
                "
              >
                <span>发消息</span>
              </div> -->


            </div>
            <div
              v-show="noa"
              style="
                margin-top: 90px;
                color: #d5d5d5;
                width: 100%;
                height: 100%;
                text-align: center;
              "
            >
              <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
              <div style="font-size: 18px; margin-top: 20px">
                你还没有关注的人，赶快去关注吧～
              </div>
            </div>
            <div
              v-show="noaa"
              style="
                margin-top: 90px;
                color: #d5d5d5;
                width: 100%;
                height: 100%;
                text-align: center;
              "
            >
              <img src="https://oss.ansongqiubo.com/assets/personimage/longzhu.png" alt="" />
              <div style="font-size: 18px; margin-top: 20px">
                你暂时还没有粉丝～
              </div>
            </div>
          </div>
        </div>
        <div class="yonghuyemian-bottom-bottom-right">
          <!-- <div style="box-sizing: border-box;padding: 20px;height: 104px;background-color: rgba(25, 25, 25, 1);">
                    <div style="height: 65px;border-radius: 4px;border: 1px solid rgba(153, 153, 153, 1);width: 260px;">
                        <div class="file">
                          <input type="file" class="avatar-input" accept="video/*"  @change="getvideo($event)"/>
                          <div v-if="video" style="position: relative;">
                            <video :src="video" class="avatar">您的浏览器不支持视频播放</video>
                            <div style="line-height: 57px;color:#ffffff;width: 476px;height: 57px;position: absolute;bottom:0;border-radius: 0px 0px 6px 6px;background: rgba(0, 0, 0, 0.5);">
                              <div style="text-align: center;">重新上传 +</div>
                              <input type="file" style="opacity: 0;width: 476px;height: 57px;position: absolute;top:0;" accept="video/*"  @change="getvideo($event)"/>
                            </div>
                          </div>
                          <div v-else class="avatar-uploader-icon" style="display: flex;align-items: center;">
                            <i class="el-icon-plus" style="font-size:35px;color:#ffffff;"></i>
                            <div style="color:#ffffff;margin-left:10px;">上传视频</div>
                          </div>
                        </div>
                    </div>
                </div> -->
          <div
            style="
              box-sizing: border-box;
              padding: 20px;
              height: 200px;
              background-color:#fff;
            "
            v-if="data.userInfo"
          >
            <div style=" font-size: 18px">个人资料</div>
            <div style="margin-top: 20px; color: #a6a6a6; font-size: 14px">
              龙珠号&nbsp;&nbsp;{{ data.userInfo.account }}
            </div>
            <div style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              性别&nbsp;&nbsp;&nbsp;&nbsp;
              <span v-if="data.userInfo.gender == 1">男</span>
              <span v-if="data.userInfo.gender == 2">女</span>
              <span v-if="data.userInfo.gender == 0">保密</span>
            </div>
            <div style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              生日&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
                data.userInfo.birthday
              }}</span>
            </div>
            <div style="margin-top: 10px; color: #a6a6a6; font-size: 14px">
              地区&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
                data.userInfo.region
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Nav from "../component/Nav.vue";
export default {
  data() {
    return {
      a: true,
      aa: false,
      video: "",
      data: [],
      fensidata: [],
      guanzhudata: [],
      huxiangguanzhu: true,
      guanzhu: false,
      faxiaoxi: true,
      Zhankai: true,
      noa: false,
      noaa: false,
      henggang: 1,
    };
  },
  mounted() {
    if(!localStorage.getItem('token')){
      this.$router.replace('/')
      return
    }
    // 个人信息接口
     this.$store.dispatch('getUserInfoData').then((result) => {
        this.data =result;
      });
    // 关注列表
    this.$axios
      .get(this.api + "/v1/relation/follow", {
        params: {},
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log(res);
        this.guanzhudata = res.data.data;
        this.Zuopin();
      });
    // 粉丝列表
    this.$axios
      .get(this.api + "/v1/relation/fans", {
        params: {},
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log(res);
        this.fensidata = res.data.data;
      });
  },
  methods: {
    // 用户简介展开收起
    zhankai() {
      this.$refs.zhankai.style.height = "80px";
      this.Zhankai = false;
    },
    shouqi() {
      this.$refs.zhankai.style.height = "26px";
      this.Zhankai = true;
    },
    dateFormat: function (time) {
      var times = time * 1000;
      var date = new Date(times);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    Zuopin() {
      this.henggang = 1;
      if (
        this.guanzhudata.later.length <= 0 &&
        this.guanzhudata.today.length <= 0
      ) {
        this.noa = true;
        this.noaa = false;
        this.a = false;
        this.aa = false;
      } else {
        this.noaa = false;
        this.noa = false;
        this.a = true;
        this.aa = false;
      }
    },
    Shoucang() {
      this.henggang = 2;
      if (
        this.fensidata.later.length <= 0 &&
        this.fensidata.today.length <= 0
      ) {
        this.noaa = true;
        this.noa = false;
        this.a = false;
        this.aa = false;
      } else {
        this.noaa = false;
        this.noa = false;
        this.a = false;
        this.aa = true;
      }
    },
    Guanzhu(e) {
      this.$axios({
        headers: {
          device: "iOS",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/relation/follow",
        method: "post",
        data: {
          actionUid: e,
        },
      }).then((res) => {
        // 刷新粉丝列表
        this.$axios
          .get(this.api + "/v1/relation/fans", {
            params: {},
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            //   console.log(res);
            this.fensidata = res.data.data;
          });
        this.$axios
          .get(this.api + "/v1/relation/follow", {
            params: {},
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log(res);
            this.guanzhudata = res.data.data;
          });
      });
    },
    quxiaoguanzhu(e) {
      console.log(e);
      this.$axios({
        headers: {
          device: "iOS",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/relation/unfollow",
        method: "post",
        data: {
          actionUid: e,
        },
      }).then((res) => {
        // 刷新粉丝列表
        this.$axios
          .get(this.api + "/v1/relation/follow", {
            params: {},
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            console.log(res);
            this.guanzhudata = res.data.data;
          });
        this.$axios
          .get(this.api + "/v1/relation/fans", {
            params: {},
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            //   console.log(res);
            this.fensidata = res.data.data;
          });
      });
    },
  },
  components: {
    Nav,
  },
};
</script>

<style scoped lang='scss'>
.file {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 260px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-input {
  opacity: 0;
  width: 260px;
  height: 65px;
  display: block;
  position: absolute;
}
.yonghuyemian {
  width: 100vw;
  height: 100vh;
  background-color: #292929;
}
.yonghuyemian-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* height: 90%; */
  box-sizing: border-box;
  padding-top: 20px;
  background-color: rgba(247, 248, 250, 1);
  min-width: 1200px;
  .yonghuyemian-bottom-top {
    margin: 0 auto;
    width: 1200px;
    height: 118px;
    background: #ffffff;
    position: relative;
  }
  .yonghuyemian-bottom-top-bottom {
    width: 1200px;
    height: 118px;
    position: relative;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .edit_user{
      width: 98px;
      height: 36px;
      text-decoration: none;
      border-radius: 4px;
      border: 1px solid #721EDC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #721EDC;
    }
    .userinfo_desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .show {
      cursor: pointer;
      color: #d5d5d5;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .hiddens {
      cursor: pointer;
      color: #d5d5d5;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .userinfo_box {
      display: flex;
      align-items: center;
    }
    .showCare_btn {
      flex: 2;
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
      .showCare_box {
        display: flex;
        flex-direction: column;
        .jubao {
          position: absolute;
          right: 20px;
          top: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .jubao:hover {
          color: #333;
        }
        .care {
          width: 98px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          background: #dadada;
          border-radius: 4px;
        }
      }
    }
    .userinfo_grede {
      width: 46px;
      text-align: center;
      margin-left: 4px;
      img{
        width: 46px;
        height: 14px;
      }
    }
    .userInfo_title {
      flex: 2;
      .name {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
    .userinfo_img {
      margin-right: 12px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
    }
  }
}

.yonghuyemian-bottom-top-top {
  width: 1200px;
  height: 160px;
  overflow: hidden;
  position: relative;
}
.yonghuyemian-bottom-top-top > div {
  width: 84px;
  height: 40px;
  border-radius: 4px;
  background-color: rgba(70, 70, 70, 1);
  text-align: center;
  line-height: 40px;
  position: absolute;
  top: 50px;
  right: 20px;
  color: white;
}
.yonghuyemian-bottom-top-center {
  width: 1200px;
  height: 80px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  position: absolute;
  top: 80px;
}

.yonghuyemian-bottom-center {
  width: 1200px;
  height: 60px;
  background-color: #fff;
  padding: 10px 40px;
  margin: 12px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .nav_item {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
  }
  .activenav {
    color: rgba(114, 30, 220, 1) !important;
  }
}
.yonghuyemian-bottom-bottom {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.yonghuyemian-bottom-bottom-left {
  width: 73%;
  box-sizing: border-box;
  padding: 10px;
  background-color: #fff;
  overflow: hidden;
   .care_btn_ok {
    width: 25%;
    display: flex;
    align-items: center;
  }
  .redia_guanzhu {
    cursor: pointer;
    margin-left: 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    border: 1px solid rgba(228, 228, 228, 0.2);
    background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
    transition: all 0.1s;
    display: flex;
    justify-content: center;
    width: 98px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
  }
  .double_care {
    cursor: pointer;
    margin-left: 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    justify-content: center;
    border: 1px solid rgba(228, 228, 228, 0.21);
    background: #dadada;
     width: 98px;
      height: 36px;
      text-align: center;
      line-height: 36px;
          img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    span {

      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .double_care:hover{
    background: #fff0f0;
    span {
      color: rgba(237, 16, 16, 1);
    }
  }
  ._fensi_list {
    width: calc(100% + 35px);
    height: 600px;
    overflow-y: scroll;
  }
  ._fensi_item {
    border-bottom: 2px solid rgba(218, 218, 218, .1);
    width: 100%;
    height: 110px;
    display: flex;
    box-sizing: border-box;
    padding: 10px 30px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .nickname {
      flex: 2;
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    align-items: flex-start;
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .desc {
      margin-top: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .header_class {
    text-align: center;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    img {
      border-radius: 50%;

      width: 60px;
      height: 60px;
    }
  }
}
.yonghuyemian-bottom-bottom-right {
  width: 25%;
  margin-left: 2%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/component/Gerenyemian.vue